import { GlobalStateContext } from "GlobalState"
import Icon from "components/Icon"
import { AnimatePresence, motion } from "framer-motion"
import { useContext, useEffect, useState } from "react"
import { Link, useLocation } from "react-router-dom"
import colors from "styles/colors"
import { t } from "translations"
import { Column } from "./Layout"
import css from "./SettingsMenu.module.scss"

const SettingsMenu = () => {
  const location = useLocation()
  const [currentPath, setCurrentPath] = useState(location.pathname);
  const { showSettingsMenu, setShowSettingsMenu } = useContext(GlobalStateContext)

  // When pressing links in the menu we should close it
  useEffect(() => {
    if (currentPath !== location.pathname) {
      setShowSettingsMenu(false)
      setCurrentPath(location.pathname)
    }
  }, [location])

  const links = [
    { to: "/terms_of_service", label: "Terms & Conditions", icon: "terms" },
    { type: "separator" },
    { to: "/privacy_policy", label: "Privacy Policy", icon: "privacy" },
    { type: "separator" },
    { to: "/about", label: "About", icon: "read" },
  ]

  return <AnimatePresence>
    {showSettingsMenu &&
      <div className={css.settingsMenu}>
        <motion.div
          key="wash"
          className={css.wash}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4 }}
          onClick={() => setShowSettingsMenu(false)}
        />

        <motion.div
          key="menu"
          className={css.menu}
          initial={{ x: 238 }}
          animate={{ x: 0 }}
          exit={{ x: 238 }}
          transition={{ duration: 0.3 }}
        >
          <Icon style={{ alignSelf: 'flex-end' }} name="close" size={22} onClick={() => setShowSettingsMenu(false)} />

          <Column gap={30}>
            <h3>{t("settings_menu.title")}</h3>
            <Column gap={16}>
              {links.map((link, i) => {
                if (link.type === "separator")
                  return <div className={css.separator} key={i} />

                return (
                  <Link sf="msb" to={link.to} key={i} style={{ gap: 12 }}>
                    <Icon
                      name={link.icon}
                      bg="circle"
                      bgColor={colors.white10}
                      size={25}
                    />
                    <h5 col={1}>{link.label}</h5>
                    <Icon name="chevron-right" size={25} />
                  </Link>
                )
              })}
            </Column>
          </Column>

          <img src="/img/settings_bg.png" width={190} height={300} alt="" />
        </motion.div>
      </div>
    }
  </AnimatePresence>

}

export default SettingsMenu
